import React from 'react';
import styled from 'styled-components';

const WrapperStyled = styled.div`
  margin: 32px auto;
  text-align: center;
  padding: 32px;
`;

const Spinner = styled.div`
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 3px solid var(--line-strong);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
`;

const Loader = () => {
    return (
        <WrapperStyled>
            <Spinner />
        </WrapperStyled>
    );
};

export default Loader;
